
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { TransitionName } from './types'

@Component
export default class AppTransition extends Vue {
  @Prop({ type: String, required: false, default: 'fade' })
  readonly name!: TransitionName
}
